export default () => '/customers';
